import { API } from '@aws-amplify/api'

const useABTestLogger = () => {
  const sendABTestLog = async (log) => {
    const { experimentName, experimentVariant, experimentAction } = log

    if (!experimentName || !experimentVariant || !experimentAction) {
      throw new Error('Experiment name, variant and action are required parameters')
    }

    const params = {
      queryStringParameters: { ...log }
    }

    const payload = await API.post('event_bus_token_api_name', '/ab-test', params)
    console.log('AB Test Log sent successfully:', payload)
  }

  return { sendABTestLog }
}

export default useABTestLogger
